import { z } from 'zod';

export const MembershipPlanSchema = z.enum(['VIP', 'PARTNER', 'INVESTOR']);
export type MembershipPlan = z.infer<typeof MembershipPlanSchema>;

export const CreateMembershipLeadInput = z.object({
  plan: MembershipPlanSchema,
  note: z.string().max(200).optional(),
});
export type CreateMembershipLeadInput = z.infer<typeof CreateMembershipLeadInput>;

export const MembershipLeadResultDto = z.object({
  plan: MembershipPlanSchema,
  alreadySent: z.boolean(),
});
export type MembershipLeadResultDto = z.infer<typeof MembershipLeadResultDto>;

export const MembershipLeadsDto = z.object({
  plans: z.array(MembershipPlanSchema),
});
export type MembershipLeadsDto = z.infer<typeof MembershipLeadsDto>;
